import React from "react";

const buildIconProps = (size) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
});

/**
 * Archive tray icon (box with lid and shelf line).
 *
 * @example
 * <ActionItemArchiveIcon size={14} />
 */
export const ActionItemArchiveIcon = ({ size = 14 }) => (
  <svg {...buildIconProps(size)}>
    <rect x="2" y="3" width="20" height="5" rx="1" />
    <path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" />
    <path d="M10 12h4" />
  </svg>
);

/**
 * Restore / undo icon for archived tasks.
 *
 * @example
 * <ActionItemRestoreIcon size={14} />
 */
export const ActionItemRestoreIcon = ({ size = 14 }) => (
  <svg {...buildIconProps(size)}>
    <path d="M3 7v6h6" />
    <path d="M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6.364 2.636L3 13" />
  </svg>
);

/**
 * Permanent delete icon for archived tasks.
 *
 * @example
 * <ActionItemDeleteIcon size={14} />
 */
export const ActionItemDeleteIcon = ({ size = 14 }) => (
  <svg {...buildIconProps(size)}>
    <path d="M3 6h18" />
    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
  </svg>
);
